import React from "react";
import "./FAQAccordian.css";
import Heading from "./Heading";
import SubHeading from "./SubHeading";
import Description from "./Description";

const FAQAccordian = ({ faqs = [] }) => {
  const accordionId = "faqAccordion";

  return (
    <div className="container py-5" data-aos="fade-up">
      <Heading className="text-center mb-5">Frequently Asked Questions</Heading>

      <div className="accordion" id={accordionId}>
        {faqs.map((faq, idx) => {
          const headingId = `heading-${idx}`;
          const collapseId = `collapse-${idx}`;

          return (
            <div
              key={idx}
              className="accordion-item mb-2 py-2"
              // className="accordion-item mb-2 shadow-sm py-2"
              style={{
                maxWidth: "800px",
                margin: "0 auto",
              }}
            >
              <h2 className="accordion-header" id={headingId}>
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target={`#${collapseId}`}
                  aria-expanded="false"
                  aria-controls={collapseId}
                >
                 <SubHeading className="text-start">{faq.question}</SubHeading>
                </button>
              </h2>

              <div
                id={collapseId}
                className="accordion-collapse collapse"
                aria-labelledby={headingId}
                data-bs-parent={`#${accordionId}`}
              >
                <div className="accordion-body"><Description>{faq.answer}</Description></div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default FAQAccordian;
